import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ServiceContactDelegation } from "../../Model/ServiceContactDelegation/ServiceContactDelegation";


export async function deleteServiceContactDelegationService(id) {
    let response = await getAPIResponse("/v1/service-contact-delegation/" + id, {}, "DELETE");
    if (response === null) {
        return null;
    }
    let serviceContactDelegation = ServiceContactDelegation.createFromResponseData(response);
    return serviceContactDelegation;
}
